import React, { useContext, useEffect, useState } from "react";
import { SetdataContext } from "../context/SetdataContext";

function FormData() {
    
    const {sectionsState, loadProyect, getSections, msj} = useContext(SetdataContext)

    const [data, setSection] = useState({
        language: "", 
        sectionName: "",
        sectionID: "",
        sectionOrden: sectionsState.length,
        proyectName: "",
        nameID: "",
        proyectLink: "",
        proyectShortDesc: "",
        proyectLongDesc: "",
        proyectImages: "",
        proyectImgDesc: "",
        proyectRol: "",
        proyectTasks: "",
        proyectCoworkers: ""
    })

    const chageInput = (e) => {
        setSection({
            ...data,
            [e.target.name]: e.target.value
        })
    }

    const chageLanguage = (e) => {
        setSection({
            ...data,
            [e.target.name]: e.target.value
        })

        getSections(e.target.value)
    }
    const chageSelec = (e) => {
        document.querySelector("#sectionName"). value = e.target.value
    }

    const submit = (e) =>{
        e.preventDefault()
        document.querySelector(".form__popup").style.display = "flex"
        console.log(data);
        loadProyect(data)
    }

    const addImg = () => {
        console.log("add input");
        const input = document.createElement("input")
        input.className = "imgInput"
        input.type = "file"
        input.name = "images"
        document.querySelector("#imgInput").appendChild(input)
    }

    const removeImg = () => {
        const div = document.querySelector("#imgInput")
        div.removeChild(div.lastChild)
    }

    const cerrar = () =>{
        document.querySelector(".form__popup").style.display = "none"
    }

    useEffect(() => {
        console.log(msj);
    }, [msj])

    return(
        <form className="form" onSubmit={submit}>
            <div className="form__language">
                <label htmlFor="language">Idioma: </label>
                <select  id="languageSelect" name="language" onChange={chageLanguage}>
                    <option></option>
                    <option value="ingles">Ingles</option>
                    <option value="español">Español</option>
                </select>
            </div>

            <div className="form__section">
                <label htmlFor="sectionName">Seccion: </label>
                <input type="text" name="sectionName" id="sectionName" className="sectionName" onChange={chageInput}/>
                <br></br>
                <label htmlFor="sectionID">SeccionID: </label>
                <input type="text" name="sectionID" id="sectionID" className="sectionID" placeholder="Debe ser igual en ambos idiomas" onChange={chageInput}/>
            </div>

            <div className="form__proyectName">
                <label htmlFor="proyectName">Proyecto: </label>
                <input type="text" name="proyectName" id="proyectName" onChange={chageInput}/>
                <br />
                <label htmlFor="nameID">NameID: </label>
                <input type="text" name="nameID" id="nameID" placeholder="Debe ser igual en ambos idiomas" onChange={chageInput}/>
            </div>

            <div className="form__proyectLink">
                <label htmlFor="proyectLink">Link: </label>
                <input type="text" name="proyectLink" id="proyectLink" onChange={chageInput}/>
            </div>

            <div className="form__proyectShortDesc">
                <label htmlFor="proyectShortDesc">Descripcion Corta</label>
                <br></br>
                <textarea name="proyectShortDesc" id="proyectShortDesc" onChange={chageInput}/>
            </div>

            <div className="form__proyectLongDesc">
                <label htmlFor="proyectLongDesc">Descripcion Larga</label>
                <textarea name="proyectLongDesc" id="proyectLongDesc" onChange={chageInput}/>
            </div>

            <div className="form__proyectImages">
                <label htmlFor="images">Imagenes: </label>
                <div id="imgInput">
                    <input className="imgInput" type="file" name="images"/>
                </div>                
                <button type="button" className="addImg" onClick={addImg}>+</button>
                <button type="button" className="removeImg" onClick={removeImg}>-</button>
            </div>

            <div className="form__proyectImgDesc">
                <label htmlFor="proyectImgDesc">Descripcion de Imagenes (JSON array): </label>
                <textarea name="proyectImgDesc" id="proyectImgDesc" onChange={chageInput}/>
            </div>

            <div className="form__proyectRol">
                <label htmlFor="proyectRol">Rol: </label>
                <textarea name="proyectRol" id="proyectRol" onChange={chageInput}/>
            </div>

            <div className="form__proyectTasks">
                <label htmlFor="proyectTasks">Tareas (JSON array): </label>
                <textarea name="proyectTasks" id="proyectTasks" onChange={chageInput}/>
            </div>

            <div className="form__proyectCoworkers">
                <label htmlFor="proyectCoworkers">Coworkers (JSON name: "", link: ""): </label>
                <textarea name="proyectCoworkers" id="proyectCoworkers" onChange={chageInput}/>
            </div>

            <button type="submit" className="form__sendButton">Enviar</button>

            <div className="form__popup">
                {msj[0].map((m) => {return(<p>{m}</p>)})}
                {msj[1].map((m) => {return(<p>{m}</p>)})}
                {msj[2].map((m) => {return(<p>{m}</p>)})}

                <button type="button" onClick={() => cerrar()}>CERRAR</button>
            </div>
        </form>
    )
}

export default FormData